import React from 'react';
import { Outlet } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import publicTheme from 'core/theme/publicTheme';
import 'core/styles/public.css';

/** Scopes the modern public-site theme (and font) to the public routes only. */
function PublicShell() {
    return (
        <ThemeProvider theme={publicTheme}>
            <div className="jf-public">
                <Outlet />
            </div>
        </ThemeProvider>
    );
}

export default PublicShell;
